module.exports = __webpack_public_path__ + "static/media/eat-wisely.04442185.jpg";